const DEFAULT_QUERY_RETRY_COUNT = 3;

/**
 * Reads an HTTP status from the shapes this app actually throws:
 * AxiosAdapter (`statusCode` + `response.status`) and raw axios errors.
 */
export function getQueryErrorStatus(error: unknown): number | undefined {
  if (error == null || typeof error !== 'object') {
    return undefined;
  }

  const maybe = error as {
    statusCode?: unknown;
    response?: { status?: unknown; statusCode?: unknown };
  };

  if (typeof maybe.statusCode === 'number') {
    return maybe.statusCode;
  }
  if (typeof maybe.response?.status === 'number') {
    return maybe.response.status;
  }
  if (typeof maybe.response?.statusCode === 'number') {
    return maybe.response.statusCode;
  }

  return undefined;
}

/**
 * Retry network / 5xx failures, but not 4xx.
 * 403 (missing scope) and other client errors will not succeed on retry.
 */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  const status = getQueryErrorStatus(error);
  if (status != null && status >= 400 && status < 500) {
    return false;
  }
  return failureCount < DEFAULT_QUERY_RETRY_COUNT;
}
